module.exports = __webpack_public_path__ + "static/media/uk.3a0bed46.svg";